// extracted by mini-css-extract-plugin
export default {"errorPoint":"errorPoints_errorPoint__fahzQ","AC":"errorPoints_AC__40bKY","Selectivity":"errorPoints_Selectivity__iLbiR","BC":"errorPoints_BC__H2Tuk","BCx2":"errorPoints_BCx2__dxhCj"};